import TabsCustom from '@/components/_common/TabsCustom';
import MichelinSettings from '@/components/Settings/Integrations/MichelinSettings';
import { useWindowSize } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import { Divider, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import StonePage from '../StonePage';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import { useMatrix } from '@/core/domain/enterprise/Matrix/Matrix.hooks';

const { Title } = Typography;

export const initialTabErrors = {
  bankSlip: false,
  tags: false,
};

export default function IntegrationsPage({ route }: PageProps) {
  const intl = useIntl();
  const { width } = useWindowSize();

  const [menuKeyActive, setMenuKeyActive] = useState<string>('stone');
  const [shouldFilterMichelin, setShouldFilterMichelin] =
    useState<boolean>(false);

  const { data, dataUpdatedAt } = useMatrix();

  useEffect(() => {
    const shouldFilterMichelin = data?.matrixSettings.michelinIntegration;
    if (shouldFilterMichelin) {
      setShouldFilterMichelin(shouldFilterMichelin);
    }
  }, [dataUpdatedAt]);

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <div className="page-header">
        <Title level={width < 576 ? 5 : 4}>
          {intl.formatMessage({ id: route.name })}
        </Title>
      </div>

      <Divider />

      <TabsCustom
        key={menuKeyActive}
        activeKey={menuKeyActive}
        onChange={setMenuKeyActive}
      >
        {hasPermissions([
          Authorities.CONFIGURATION_MATRIX_SETTINGS,
          Authorities.STONE_MANAGER,
        ]) && (
          <TabsCustom.Item label="Stone" key="stone">
            <StonePage />
          </TabsCustom.Item>
        )}

        {shouldFilterMichelin && (
          <TabsCustom.Item label="Michelin" key="michelin">
            <MichelinSettings
              matrixSettingsId={data?.matrixSettings.id}
              michelinSupplierId={data?.matrixSettings.michelinSupplierId}
            />
          </TabsCustom.Item>
        )}
      </TabsCustom>
    </>
  );
}
